import React from "react";
import { Link, useParams } from "react-router-dom";
import { Button, Divider } from "@mui/material";
import { EditOutlined } from "@mui/icons-material";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import IncidentReportBasicDetail from "./IncidentReportComponents/IncidentReportBasicDetail";

import { useGetIncidentReportDetailQuery } from "store/services/incidentReportApi";

import {
  IncidentReportDetailContext,
  useIncidentReportDetailContext,
} from "contexts/IncidentReportDetailContext";
import IncidentReportDetailTab from "./IncidentReportComponents/IncidentReportDetailTab";

const IncidentReportDetailScreen = () => {
  const { id } = useParams();

  const breadcrumbs = [
    { title: "Incident Report", path: "/app/crm/incident-report/list" },
    { title: "Incident  Detail" },
  ];

  // RTK Query
  const {
    data: incidentReportDetail,
    isLoading: loadingIncidentReport,
    error,
  } = useGetIncidentReportDetailQuery(id);
  // console.log("full f?ill", fulfillmentDetail)

  return (
    <IncidentReportDetailContext.Provider
      value={{ incidentReportDetail, loadingIncidentReport }}
    >
      <BreadcrumbLayout
        breadcrumbs={breadcrumbs}
        isBusy={loadingIncidentReport}
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />

        <BreadcrumbLayout.Paper>
          <IncidentReportBasicDetail />
          <Divider />
          <IncidentReportDetailTab />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </IncidentReportDetailContext.Provider>
  );
};

export default IncidentReportDetailScreen;

const PageActions = () => {
  const { incidentReportDetail } = useIncidentReportDetailContext();
  // console.log("fulfillmentDetail", fulfillmentDetail);
  return (
    <div className="flex items-center gap-4">
      <Link to={`/app/crm/incident-report/${incidentReportDetail?._id}/edit`}>
        <Button startIcon={<EditOutlined />} variant="contained">
          Edit
        </Button>
      </Link>
    </div>
  );
};
